import React from 'react';
import './style.scss';
import config from '../../../../config';
import web_screen_header from '../../../../images/screen-shot.png';
import phone_screen_shot from '../../../../images/phone-screen-shot.png';
import ipad_screen_shot from '../../../../images/ipad-screen-shot.png';

function Devices({ galleryPhoto }) {
  const url = config.imagesBaseUrl;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="614"
      fill="none"
      viewBox="0 0 614 283"
      className="devices_svg"
    >
      <foreignObject
        className="pad_devices_screens_wrapper"
        x="360"
        y="65"
        width="40%"
        height="69%"
      >
        <div className="pad_devices_screen_shot_wrapper">
          <img className="pad_screen_shot" src={ipad_screen_shot} />
        </div>
        <div className="pad_device_screen_title_wrapper">
          <div className="pad_device_screen_title">Gallery</div>
          <div className="pad_device_screen_title_underline">
            <img
              src={`${url}property/assets/images/logoMin.png`}
              alt="title_unerline"
            />
          </div>
        </div>
        <div className="pad_device_screen_body_wrapper">
          {galleryPhoto?.slice(0, 2).map((elem) => (
            <div className="pad_device_screen_body_photo_wrapper" key={elem.id}>
              <img
                className="pad_device_screen_body_photo"
                src={elem.thumbnailLink}
                alt="gallery_thotos"
              />
            </div>
          ))}
        </div>
        <div className="pad_device_screen_button_wrapper">
          <div className="pad_device_screen_button">EDIT PHOTOS</div>
        </div>
      </foreignObject>

      <foreignObject
        className="note_devices_screens_wrapper"
        x="52"
        y="15"
        width="59.3%"
        height="81%"
      >
        <div className="note_devices_screen_shot_wrapper">
          <img
            className="note_devices_screen_shot_image"
            src={web_screen_header}
          />
        </div>
        <div className="note_device_screen_title_wrapper">
          <div className="note_device_screen_title">Gallery</div>
          <div className="note_device_screen_title_underline">
            <img
              src={`${url}property/assets/images/logoMin.png`}
              alt="title_unerline"
            />
          </div>
        </div>
        <div className="note_device_screen_body_wrapper">
          {galleryPhoto?.slice(0, 8).map((elem) => (
            <div
              className="note_device_screen_body_photo_wrapper"
              key={elem.id}
            >
              <img
                className="note_device_screen_body_photo"
                src={elem.thumbnailLink}
                alt="gallery_thotos"
              />
            </div>
          ))}
        </div>
        <div className="note_device_screen_button_wrapper">
          <div className="note_device_screen_button">EDIT PHOTOS</div>
        </div>
      </foreignObject>

      <foreignObject
        className="phone_devices_screens_wrapper"
        x="386"
        y="102"
        width="13.5%"
        height="62%"
      >
        <div className="phone_devices_screen_shot_wrapper">
          <img
            className="phone_devices_screen_shot_image"
            src={phone_screen_shot}
          />
        </div>
        <div className="phone_device_screen_title_wrapper">
          <div className="phone_device_screen_title">Gallery</div>
          <div className="phone_device_screen_title_underline">
            <img
              src={`${url}property/assets/images/logoMin.png`}
              alt="title_unerline"
            />
          </div>
        </div>
        <div className="phone_device_screen_body_wrapper">
          {galleryPhoto?.slice(0, 2).map((elem) => (
            <div
              className="phone_device_screen_body_photo_wrapper"
              key={elem.id}
            >
              <img
                className="phone_device_screen_body_photo"
                src={elem.thumbnailLink}
                alt="gallery_thotos"
              />
            </div>
          ))}
        </div>
        <div className="phone_device_screen_button_wrapper">
          <div className="phone_device_screen_button">EDIT PHOTOS</div>
        </div>
      </foreignObject>

      <g clipPath="url(#clip0_4045_1012)">
        <path
          fill="#DFDFDF"
          d="M351.32 58.33h-.2.36-.16zm.46 208.5h-1.28a5.306 5.306 0 01-.56-.09l-.54-.12-.52-.14-.18-.06-.29-.1-.52-.19-.5-.22-.41-.2h-.08l-.47-.26a12.273 12.273 0 01-2.13-1.61l-.37-.38a1.142 1.142 0 01-.11-.11l-.11-.11-.16-.19-.17-.19-.1-.13-.1-.13a6.844 6.844 0 01-.45-.61l-.15-.22-.14-.22c-.1-.16-.19-.31-.28-.48a.451.451 0 000-.09 1.08 1.08 0 01-.08-.15c0-.08-.09-.17-.12-.25a9.319 9.319 0 01-.78-1.6 2.423 2.423 0 01-.08-.25 1.82 1.82 0 00-.07-.25c0-.07 0-.15-.07-.23a.642.642 0 01-.06-.2v-.07-.06-.07-.07-.2c0-.07-.07-.34-.09-.51a.405.405 0 010-.11.139.139 0 010-.09 4.542 4.542 0 01-.07-.52 1.922 1.922 0 010-.24 8.416 8.416 0 010-.87v-11h-.11v11c-.001.575.039 1.15.12 1.72 0 .21.07.41.12.62.02.135.05.269.09.4.199.821.484 1.619.85 2.38l.21.4a11.689 11.689 0 0010.16 6.22h34.32v-.12l-34.72-.03zm250.4-208.64H415.69v.11h187.68l.49.06.55.1c.547.102 1.085.246 1.61.43l.51.2c.167.065.33.138.49.22l.42.19.48.27.42.25.21.14h.07l.14.09.34.25.07.06.07.05h.06l.17.14.14.12.31.28.09.09.1.1.2.19c.289.299.563.613.82.94.113.127.213.257.3.39l.14.21.31.46c.06.09.11.19.17.29.04.058.077.118.11.18 0 .05 0 .11.08.16s0 .05 0 .08c.391.74.7 1.522.92 2.33.025.079.045.159.06.24a8.365 8.365 0 01.2.96c.03.23.07.47.1.71-.005.09-.005.18 0 .27v187.12c-.005.08-.005.16 0 .24-.052.48-.128.958-.23 1.43a2.816 2.816 0 01-.07.27 1.245 1.245 0 01-.05.2 10.752 10.752 0 01-.93 2.36l-.06.12-.06.13c0 .08-.09.15-.14.23l-.15.24-.06.1-.07.11c-.05.08-.11.15-.16.22s-.24.34-.36.5l-.09.11c-.06.09-.13.17-.2.26l-.33.38-.21.22c-.06.06-.12.13-.19.19a1.618 1.618 0 01-.19.18c-.26.24-.53.48-.81.7-.415.338-.857.642-1.32.91l-.48.26h-.07l-.42.2-.5.22-.51.19-.51.17-.52.14-.55.12a4.835 4.835 0 01-.56.09H467.18v.12h135a11.71 11.71 0 0011.68-11.69V69.87a11.7 11.7 0 00-11.68-11.68zm-250.87.14h-.2.36-.16zm-5.43 1.82l-.21.15.21-.14v-.01z"
        ></path>
        <path
          fill="url(#paint0_linear_4045_1012)"
          d="M473 108.76v149.32h-5.82V108.76a7.976 7.976 0 00-.07-1v-.27a4.947 4.947 0 00-.16-.67c0-.1-.06-.2-.1-.3-.04-.1-.15-.39-.23-.58a6.049 6.049 0 00-.29-.56 7.298 7.298 0 00-.71-1l-.21-.23-.23-.17a6.174 6.174 0 00-.46-.41l-.25-.19-.19-.13-.11-.08c-.15-.1-.32-.2-.49-.29a5.88 5.88 0 00-.56-.27l-.3-.12-.28-.09-.35-.11-.24-.06h-.06l-.3-.05h-10.85a1.11 1.11 0 00-1.06 1v.11c0 .2-.02.4-.06.6.006.067.006.133 0 .2a2.005 2.005 0 01-.06.24c-.013.074-.03.148-.05.22v.05c0 .05 0 0 0 0v.08a.817.817 0 000 .07 1.443 1.443 0 01-.07.19v.05l-.06.14c-.023.052-.05.102-.08.15a.611.611 0 01-.07.14.41.41 0 010 .07v.27a.41.41 0 000 .07.184.184 0 01-.05.07v.07l-.07.07v.06a.328.328 0 01-.08.09l-.12.12-.06.06-.11.11-.09.08-.05.05-.13.11-.13.1-.07.06h-.07l-.09.06-.09.05-.12.08-.16.08h-.06a.296.296 0 01-.11.06h-.11l-.09.05-.2.07-.12.05h-.37l-.22.06H408.26l-.23-.06h-.37l-.12-.05-.2-.07-.09-.05h-.11a.248.248 0 01-.11-.06h-.06l-.15-.08-.12-.08-.09-.05h-.05l-.09-.06h-.07l-.08-.06-.12-.1-.08-.06v-.05l-.06-.05-.08-.08a1.142 1.142 0 01-.11-.11l-.06-.06-.06-.06-.06-.06-.08-.09-.05-.06-.06-.07-.05-.07-.05-.07v-.25a.451.451 0 010-.09.165.165 0 010-.07.611.611 0 01-.07-.14 1.08 1.08 0 01-.08-.15c0-.06 0-.12-.08-.19s-.05-.13-.08-.19a.273.273 0 010-.07v-.08-.05c0-.05 0 0 0 0l-.06-.22a1.966 1.966 0 01-.05-.24 1.113 1.113 0 010-.2 4.026 4.026 0 01-.06-.6v-.15a1.119 1.119 0 00-1.06-1h-11.08a6.73 6.73 0 00-6.29 6.72v149.22h-34.31a2.704 2.704 0 01-.64-.08 3.002 3.002 0 01-.93-.4 2.579 2.579 0 01-.66-.62 2.799 2.799 0 01-.59-1.72v-11h31.31v-135.5a12.559 12.559 0 0112.51-12.56h22.47V67.06h9.54V96.2h35.21a12.562 12.562 0 0112.6 12.56z"
        ></path>
        <path
          fill="#000"
          d="M352.18 258.26a2.888 2.888 0 01-1.21-.26 3.004 3.004 0 01-.66-.4 3.464 3.464 0 01-.59-.62 2.997 2.997 0 01-.54-1.72v-11h-7.5v12.29l.06.43c0 .17.06.35.1.52v.06c0 .06.07.27.1.4.233.832.569 1.631 1 2.38.07.14.15.27.23.4.08.13.15.24.23.35l.27.39a10.392 10.392 0 001.19 1.34l.28.26.53.44.56.41.54.34c.178.11.361.21.55.3.5.262 1.022.479 1.56.65l.46.14a10.008 10.008 0 001.56.3l.54.05h34.98v-7.51l-34.24.06zm250-198.89H415.69v7.51h186.49a2.998 2.998 0 013 3v185.38c0 .796-.316 1.559-.879 2.121a2.996 2.996 0 01-2.121.879h-135v7.51h135a10.524 10.524 0 007.429-3.081 10.524 10.524 0 003.081-7.429V69.88a10.523 10.523 0 00-10.51-10.51z"
        ></path>
        <path
          fill="url(#paint1_linear_4045_1012)"
          d="M606.26 59.117l-.22-.087a10.894 10.894 0 00-1.61-.43l-.495-.09h-.165l-.51-.07h.13l.49.06.055.01h.385l.45.11.47.13.39.13c.214.066.425.145.63.236z"
        ></path>
        <path
          fill="url(#paint2_linear_4045_1012)"
          d="M345.91 60.14l-.21.14.21-.15v.01z"
        ></path>
        <path
          fill="url(#paint3_linear_4045_1012)"
          d="M350.69 266.74h-.19l-.56-.1-.54-.12-.52-.14-.18-.05-.29-.1-.52-.19-.5-.22-.41-.2h-.08l-.47-.26a12.273 12.273 0 01-2.13-1.61l-.37-.38a1.142 1.142 0 01-.11-.11l-.1-.11-.17-.19c-.06-.06-.11-.13-.16-.19l-.11-.13-.1-.13a7.046 7.046 0 01-.45-.61l-.15-.22-.14-.22c-.1-.16-.19-.31-.28-.48a.451.451 0 000-.09 1.197 1.197 0 01-.08-.15c0-.08-.09-.17-.12-.25a9.42 9.42 0 01-.78-1.51 2.423 2.423 0 01-.08-.25c-.06-.16-.1-.32-.15-.48-.05-.16 0-.13 0-.2v-.07-.06-.07a.206.206 0 010-.07 1.335 1.335 0 010-.2c0-.17-.07-.34-.1-.51a.405.405 0 010-.11.139.139 0 010-.09 4.776 4.776 0 01-.07-.52 1.922 1.922 0 010-.24v-11.87h1.08v12.72c0 .208.02.416.06.62v.4c0 .06 0 .26.07.39s.07.34.12.5c.05.16.08.31.13.46.05.15.09.3.14.44.05.14.07.18.1.27.039.084.073.171.1.26l.19.4.11.23.13.27.24.42.13.21c0 .07.09.14.14.21a.916.916 0 00.12.17c.071.111.148.217.23.32.1.14.2.27.31.4l.29.34.08.09.31.32.3.29.13.11.26.23.09.07.36.29.3.21c.069.056.143.106.22.15l.37.24.28.16.15.08.28.14c.122.07.249.13.38.18l.28.13.63.24.35.11.42.12.51.11.3.06h.25l-.03.14z"
        ></path>
        <path
          fill="url(#paint4_linear_4045_1012)"
          d="M612.69 68.8v1.08a10.523 10.523 0 00-10.51-10.51H415.69V58.3h187.54l.51.07h.55l.45.11.47.13.39.13c.278.086.548.193.81.32l.24.11c.13.052.257.112.38.18l.41.23.28.17.25.16c.13.08.26.18.38.27.12.09.25.19.36.28a.274.274 0 01.08.07c.12.09.23.19.34.29.11.1.25.23.37.35l.3.32.09.09.29.34.31.39.23.33.12.17.13.21c.047.068.09.138.13.21.08.14.17.28.24.42.07.14.09.18.14.26.05.08.2.43.29.64l.09.22.12.32c.05.14.09.28.14.43l.12.43c.049.16.089.325.12.49 0 .12.05.24.07.37.153.653.24 1.32.26 1.99z"
        ></path>
        <path
          fill="url(#paint5_linear_4045_1012)"
          d="M386.49 265.77v1.07h-35.37l-.51-.06h-.25l-.3-.06-.51-.11-.42-.12-.35-.11-.63-.24-.28-.13a2.692 2.692 0 01-.38-.18l-.28-.14-.15-.08-.28-.16-.37-.24a1.666 1.666 0 01-.23-.23l-.3-.21-.36-.29-.09-.07-.26-.23-.13-.11-.3-.29-.31-.32-.08-.09-.29-.34c-.11-.13-.21-.26-.31-.4a3.809 3.809 0 01-.23-.32.871.871 0 01-.12-.17c-.05-.07-.1-.14-.14-.21l-.13-.21-.24-.42-.13-.27-.11-.23-.19-.4a1.993 1.993 0 00-.1-.26c0-.09-.06-.18-.1-.27-.04-.09-.1-.29-.14-.44-.04-.15-.09-.3-.13-.46-.04-.16-.08-.33-.12-.5-.04-.17-.05-.26-.07-.39-.02-.13 0 0 0-.06v-.34a3.225 3.225 0 01-.06-.62V255.34v1.29l.06.43c0 .17.06.35.1.52v.06c0 .06.07.27.1.4.233.832.569 1.631 1 2.38.07.14.15.27.23.4.08.13.15.24.23.35l.27.39a10.392 10.392 0 001.19 1.34l.28.26c.17.16.35.3.53.44l.56.41.54.34c.178.11.361.21.55.3.5.262 1.022.479 1.56.65l.46.14a10.008 10.008 0 001.56.3l.54.05h.66l34.33-.02z"
        ></path>
        <path
          fill="url(#paint6_linear_4045_1012)"
          d="M386.49 260.78v7.75H50.81A170.366 170.366 0 010 260.78h386.49z"
        ></path>
        <path
          fill="url(#paint7_linear_4045_1012)"
          d="M467.85 260.78c-.23.08-.45.15-.68.21v-.21h.68z"
        ></path>
        <path
          fill="url(#paint8_linear_4045_1012)"
          d="M0 257.98v2.78h188.59c1.858.017 3.707.252 5.51.7l.65.14v-3.62H0z"
        ></path>
        <path
          fill="url(#paint9_linear_4045_1012)"
          d="M386.49 257.98v2.78H279.25a23.857 23.857 0 00-5.51.7l-.64.14v-3.62h113.39z"
        ></path>
        <path
          fill="url(#paint10_linear_4045_1012)"
          d="M467.85 258h-.68v2.78h.68V258z"
        ></path>
        <path
          fill="url(#paint11_linear_4045_1012)"
          d="M273.1 257.98v3.62c-.808.148-1.628.222-2.45.22h-73.47a13.316 13.316 0 01-2.44-.22v-3.62h78.36z"
        ></path>
        <path
          fill="url(#paint12_linear_4045_1012)"
          d="M0 257.6v2.78h188.59c1.858.017 3.707.252 5.51.7l.65.13v-3.61H0z"
        ></path>
        <path
          fill="url(#paint13_linear_4045_1012)"
          d="M413.59 1.67H54.32a11.67 11.67 0 00-11.66 11.66v243.65h1.67V11.66v-.76c0-.25.05-.49.09-.74.032-.246.079-.49.14-.73.01-.082.03-.163.06-.24 0-.16.08-.32.13-.47a9.436 9.436 0 01.76-1.79 4.49 4.49 0 01.24-.42c.06-.1.12-.2.19-.3.254-.391.538-.762.85-1.11l.27-.29c.045-.064.099-.121.16-.17l.35-.34a10.129 10.129 0 012.27-1.55l.33-.15c.146-.072.296-.135.45-.19l.23-.08.4-.14.24-.07c.143-.05.29-.09.44-.12l.46-.1.36-.06h.29c.09-.01.18-.01.27 0 .32 0 .64-.05 1-.05H414.72c.25 0 .49.06.74.11.358.069.712.159 1.06.27.236.067.466.15.69.25a9.97 9.97 0 011.1.51c.637.338 1.231.75 1.77 1.23.095.074.185.154.27.24.081.068.158.142.23.22l.07.07c.047.036.088.08.12.13.11.11.22.23.32.35.1.12.37.45.54.68a11.253 11.253 0 01.9 1.49c.11.23.21.47.3.71.129.326.236.66.32 1 0 .13.07.26.1.39l.09.44v.3c.03.152.05.306.06.46.04.352.06.706.06 1.06v96.6h1.69V12.63a11.66 11.66 0 00-11.56-10.96z"
        ></path>
        <path
          fill="url(#paint14_linear_4045_1012)"
          d="M42.64 11.66A11.662 11.662 0 0154.3-.02h359.27a11.662 11.662 0 0111.66 11.66v.93a11.66 11.66 0 00-11.64-10.92H54.32a11.67 11.67 0 00-11.66 11.66l-.02-1.65z"
        ></path>
        <path fill="#1B1B1B" d="M386.49 248.79H44.33v8.19h342.16v-8.19z"></path>
        <path
          fill="#000"
          d="M345.47 60.43l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm4.49-1.27h-.2.36-.16zm64.37 1v36.83h-22.51a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h45.89v-140a6.73 6.73 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V58.44l-6.91.89zm-64.37-1h-.2.36-.16zm-4.49 1.27l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1zm0 0l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm4.49-1.27h-.2.36-.16zm64.37 1v36.83h-22.51a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h45.89v-140a6.73 6.73 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V58.44l-6.91.89zm-64.37-1h-.2.36-.16zm-4.49 1.27l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1zm0 0l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm4.49-1.27h-.2.36-.16zm64.37 1v36.83h-22.51a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h44.37v-4.53h1.52v-135.5a6.73 6.73 0 016.29-6.72h30.76V59.34l-7.85-.01zm-64.21-1.05h-.36.36zm-4.61 1.27l-.47.27.47-.26v-.01zm-1 .55l-.21.15.21-.14v-.01zm-.44.29l.14-.1-.14.1zm78-49.83a3.56 3.56 0 00-.06-.46v-.3l-.09-.44c0-.13-.06-.26-.1-.39a7.78 7.78 0 00-.32-1c-.09-.24-.19-.48-.3-.71a11.254 11.254 0 00-.9-1.49 8.95 8.95 0 00-.54-.68c-.19-.22-.21-.24-.32-.35a.486.486 0 00-.12-.13l-.07-.07a2.364 2.364 0 00-.23-.22 2.901 2.901 0 00-.27-.24 9.016 9.016 0 00-1.77-1.23 9.966 9.966 0 00-1.1-.51 5.126 5.126 0 00-.69-.25 9.169 9.169 0 00-1.8-.38H54.3c-.32 0-.64 0-1 .05-.09-.01-.18-.01-.27 0h-.29l-.36.06-.46.1c-.15.03-.296.07-.44.12l-.24.07-.4.14a.92.92 0 00-.23.09 4.323 4.323 0 00-.45.19l-.33.15a10.13 10.13 0 00-2.27 1.55l-.35.34a.852.852 0 00-.16.17l-.27.29a9.063 9.063 0 00-.85 1.11c-.07.1-.13.2-.19.3a4.49 4.49 0 00-.24.42 9.436 9.436 0 00-.89 2.26c-.03.077-.05.158-.06.24-.061.24-.108.484-.14.73 0 .25-.07.49-.09.74v237.89h342.17v-140a6.73 6.73 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V10.7a9.29 9.29 0 00.88-.1l-.05-.04zm-7.79 85.6h-22.46a12.559 12.559 0 00-12.56 12.56v135.5H52.18v-228h363.51l-.05 79.94zm-64.57-37.85h.36-.36zm-4.76 1.52l.47-.26-.47.26zm-.68.43l.21-.14-.21.14zm-.21.14l.14-.1-.14.09v.01zm0 0l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm4.49-1.27h-.2.36-.16zm64.37 1v36.83h-22.46a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h45.89v-140a6.73 6.73 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V58.41l-6.96.89zm-64.37-1h-.2.36-.16zm-4.49 1.27l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1zm0 0l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm4.49-1.27h-.2.36-.16zm64.37 1v36.83h-22.46a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h45.89v-140a6.73 6.73 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V58.41l-6.96.89zm-64.37-1h-.2.36-.16zm-4.49 1.27l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1zm0 0l.14-.1-.14.1zm.42-.28l-.21.15.21-.14v-.01zm.94-.55l-.47.27.47-.26v-.01zm68.86-.23v36.83h-22.46a12.559 12.559 0 00-12.56 12.56v135.5H340.6v4.53h45.89v-140a6.727 6.727 0 016.29-6.72h10.14a1.122 1.122 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.05.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06H422.6V58.45l-6.96.89zm-68.86.23l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1z"
        ></path>
        <path
          fill="url(#paint15_linear_4045_1012)"
          d="M386.49 257.6v2.78H279.25a22.453 22.453 0 00-4.09.4c-.47.09-1 .19-1.42.3l-.64.13v-3.61h113.39z"
        ></path>
        <path
          fill="url(#paint16_linear_4045_1012)"
          d="M467.85 257.6h-.68v2.78h.68v-2.78z"
        ></path>
        <path
          fill="url(#paint17_linear_4045_1012)"
          d="M273.1 257.6v3.61c-.808.152-1.628.229-2.45.23h-73.47a13.223 13.223 0 01-2.44-.23v-3.61h78.36z"
        ></path>
        <path fill="#0B0B0B" d="M386.49 256.98H42.66v.62h343.83v-.62z"></path>
        <path
          fill="url(#paint18_linear_4045_1012)"
          d="M345.61 60.34l-.14.1.14-.1z"
        ></path>
        <path
          fill="url(#paint19_linear_4045_1012)"
          d="M345.91 60.14l-.21.14.21-.15v.01z"
        ></path>
        <path
          fill="url(#paint20_linear_4045_1012)"
          d="M346.87 59.59l-.47.26.47-.27v.01z"
        ></path>
        <path
          fill="url(#paint21_linear_4045_1012)"
          d="M415.69 96.2v12.06h-7.48l-.23-.06h-.37l-.12-.05-.2-.07-.09-.05h-.11a.248.248 0 01-.11-.06h-.06l-.15-.08-.12-.08-.09-.05h-.05l-.09-.06h-.07l-.08-.06-.12-.1-.08-.06v-.05l-.06-.05-.08-.08a1.142 1.142 0 01-.11-.11l-.06-.06-.06-.06-.06-.06-.08-.09-.05-.06-.06-.07-.05-.07-.05-.07v-.25a.451.451 0 010-.09.165.165 0 010-.07.611.611 0 01-.07-.14 1.08 1.08 0 01-.08-.15c0-.06 0-.12-.08-.19s-.05-.13-.08-.19a.273.273 0 010-.07v-.08-.05c0-.05 0 0 0 0l-.06-.22a1.966 1.966 0 01-.05-.24 1.113 1.113 0 010-.2 4.026 4.026 0 01-.06-.6v-.15a1.119 1.119 0 00-1.06-1h-11.03a6.727 6.727 0 00-6.29 6.72v135.5h-5.83v-135.5a12.564 12.564 0 017.504-12.432 12.558 12.558 0 015.016-1.048h22.51z"
        ></path>
        <path
          fill="url(#paint22_linear_4045_1012)"
          d="M351.32 58.33h-.2.36-.16zM413.57-.02h-41.24l-1.67 1.67-14.53 14.53h59.58v80h-22.53a12.559 12.559 0 00-12.56 12.56v135.5H128.07l-4.53 4.53-8.81 8.81h271.76V108.76a6.725 6.725 0 011.817-4.603 6.726 6.726 0 014.473-2.117h10.14a1.125 1.125 0 011.06 1v.15c.005.201.025.402.06.6a1.113 1.113 0 000 .2c.012.081.028.161.05.24l.06.22v.05c0 .05 0 0 0 0v.08a.273.273 0 000 .07c0 .06 0 .13.08.19s0 .13.08.19c.023.052.049.102.08.15a.611.611 0 00.07.14.165.165 0 000 .07.451.451 0 000 .09v.25l.05.07.05.07.06.07.05.06.08.09.06.06.06.06.06.06c.034.039.071.076.11.11l.08.08.06.05v.05l.08.06.12.1.08.06h.07l.09.06h.05l.09.05.12.08.15.08h.06c.031.029.069.05.11.06h.11l.09.05.2.07.12.05h.37l.23.06h16.97v-96.6A11.66 11.66 0 00413.57-.02zm-66.74 59.6l-.47.27.47-.26v-.01zm-.94.55l-.21.15.21-.14v-.01zm-.42.28l.14-.1-.14.1z"
          opacity="0.2"
        ></path>
        <path
          fill="#C7C7C7"
          d="M471.36 272.05v-.243c-.03.101-.03.205-.03.303v-.48l.03-.06.07-.03v.004l.04-.014a.405.405 0 010 .11.463.463 0 00-.029.065l-.001.005-.003.006c-.037.107-.037.219-.037.324v-.232c-.03.1-.03.204-.03.302v-.269c-.01.07-.01.141-.01.209zM465.04 98.71l-.21-.09-.25-.11h.063l-.023-.01h.09l.278.124.132.016.14.07h-.08l-.192-.086-.085-.01.226.1.091.006h-.08l-.011-.005-.089-.005zM461.98 97.83h.15a.8.8 0 01-.15 0zM461.775 97.78h.015l.007.045.003.005h-.002l.002.01-.75-.06h.125l-.125-.01h.72l.005.01zM386.78 278.95a.328.328 0 01-.09-.08l.2.15-.11-.07zM385.42 277.78c.22.22.45.43.69.63l.35.29-.29-.23-.1-.08a12.275 12.275 0 01-.289-.258c.107.103.217.205.329.308l.35.29-.089-.071.049.041-.29-.23-.1-.08c-.23-.2-.45-.4-.65-.61.095.095.192.188.29.279a7.344 7.344 0 01-.25-.249v-.03zM384.93 277.29l.094.102.016-.012a.191.191 0 00.035.075l.025.025.01.01a.163.163 0 01-.02-.017.21.21 0 01-.035-.038l-.012-.012a.197.197 0 00.027.067l-.09-.09-.09-.11.11.12.017-.013-.007-.007-.09-.11.017.019-.007-.009zM382.18 257.63V107.98c.06-.32.11-.61.15-.87.04-.26.09-.52.15-.78.051-.26.118-.518.2-.77v-.001c.05-.17.1-.339.16-.499.238-.696.546-1.366.92-2l.23-.37c.09-.15.19-.29.29-.43.1-.14.2-.28.31-.41.21-.272.433-.532.67-.78l.34-.34c.18-.18.37-.34.56-.5.123-.111.254-.215.39-.31l.45-.33.46-.3a7.55 7.55 0 01.73-.41 10.549 10.549 0 011.55-.66c.19-.064.436-.132.624-.184l.028-.008.168-.048c.036-.01.073-.022.109-.034.134-.043.27-.086.411-.086l.194-.04c.256-.053.528-.11.806-.11h1.1l29.42-.92v.968l.94.002v4.36h-.94v5.22h-15.28l-.23-.06h-.37l-.12-.05-.2-.07-.09-.05h-.11a.248.248 0 01-.11-.06h-.06l-.15-.08-.12-.08-.09-.05h-.05l-.09-.06h-.07l-.08-.06-.12-.1-.08-.06v-.05l-.06-.05-.08-.08a1.142 1.142 0 01-.11-.11l-.06-.06-.06-.06-.06-.06-.08-.09-.05-.06-.06-.07-.05-.07-.05-.07v-.17a.483.483 0 01-.001-.085l-.001-.013a.163.163 0 01.001-.063.6.6 0 01-.069-.139 1.08 1.08 0 01-.08-.15c-.08-.06 0-.13-.08-.19s-.08-.13-.08-.19a.273.273 0 010-.07v-.01a.273.273 0 010-.07v-.05l-.06-.22a1.966 1.966 0 01-.05-.24c-.004-.047-.005-.093-.004-.14a1.094 1.094 0 010-.081 4.157 4.157 0 01-.056-.579V103.12a1.119 1.119 0 00-1.06-1h.365a1.15 1.15 0 00-.117-.04H392.78a6.726 6.726 0 00-4.473 2.117 6.724 6.724 0 00-1.817 4.594V257.64h-4.31v-.01zM384.41 276.65l-.122-.164a.79.79 0 01.043.076l.079.108-.075-.101a.732.732 0 01.035.081l-.2-.27a.558.558 0 01-.09-.14l.04-.03c.06.14.19.27.29.44zM382.62 273.08v.06a.451.451 0 010-.09.426.426 0 00-.04.09v-.06l.04-.03v.03zM382.37 272.08v.08a.273.273 0 010 .07.338.338 0 010-.11v-.03M382.37 272.057v.014l.01-.021-.01.007z"
        ></path>
        <path
          fill="#C7C7C7"
          d="M382.37 272.071v-.014l-.022.017-.008.034v.042a.195.195 0 01.002.025.372.372 0 01.028-.104zM464.59 98.57h.09l.459.205.091.005h-.12l-.011-.005-.089-.005-.21-.09-.25-.11h.04zM461.95 97.89h.15a.8.8 0 01-.15 0zM461.72 97.84h.04l.01.06-.041-.003.001.003-.75-.06h.74zM386.732 278.945a.325.325 0 01-.082-.075l.04.03.16.12.04.03-.11-.07a.327.327 0 01-.048-.035zM382.34 272.108l.008-.034-.008.006v.028zM382.342 272.175c.001.015 0 .03-.002.045 0-.015 0-.03.002-.045zM387.18 269.98l.09.1a.714.714 0 00-.09-.1zM382.61 273.1v.05a.417.417 0 010-.05z"
        ></path>
        <path
          fill="url(#paint23_linear_4045_1012)"
          d="M392.05 280.98h-.29l-.57-.08a12.418 12.418 0 01-3.27-1.05l-.22-.11-.54-.29-.24-.14c-.4-.243-.784-.51-1.15-.8l-.2-.15c-.2-.16-.39-.32-.57-.49l-.18-.17-.21-.2a1.888 1.888 0 00-.2-.2l-.12-.14-.16-.17a13.287 13.287 0 01-.88-1.1l-.14-.21c-.15-.21-.28-.43-.41-.65l-.14-.25a11.595 11.595 0 01-.86-1.9l-.09-.27c-.15-.458-.271-.926-.36-1.4l-.06-.29a12.81 12.81 0 01-.17-2.06V109.92a12.218 12.218 0 0111.64-12.19 11.052 11.052 0 00-10.47 11v161.25a11.06 11.06 0 009.86 11z"
        ></path>
        <path
          fill="url(#paint24_linear_4045_1012)"
          d="M472.65 109.92v158.89c0 1.273-.199 2.538-.59 3.75l-.09.27-.1.27a1.635 1.635 0 01-.08.2c-.08.2-.16.39-.25.59l-.12.25-.18.35c0 .08-.08.16-.13.24-.05.08-.09.16-.14.24-.05.08-.27.45-.41.67l-.15.2-.16.23-.17.22-.17.22-.19.22c-.12.14-.24.28-.37.41-.13.13-.4.42-.61.61l-.19.18-.45.38-.2.16c-.22.17-.45.33-.68.49l-.24.15-.48.29-.24.14c-.27.14-.53.28-.81.4l-.22.1-.26.1-.26.11-.61.2-.21.07c-.267.08-.537.15-.81.21l-.29.06-.31.06-.57.08h-.29a11.062 11.062 0 009.87-11V108.76a11.067 11.067 0 00-10.17-11 12.23 12.23 0 0111.33 12.16z"
        ></path>
        <path
          fill="url(#paint25_linear_4045_1012)"
          d="M472.65 268.81v1.17a12.23 12.23 0 01-12.21 12.22h-67.26a12.233 12.233 0 01-12.17-12.22v-1.16c.001.69.058 1.379.17 2.06l.06.29c.089.474.21.942.36 1.4l.09.27c.229.658.517 1.294.86 1.9l.14.25c.13.22.26.44.41.65l.14.21c.274.382.567.749.88 1.1l.16.17.12.14c.072.062.138.128.2.2l.21.2.18.17c.18.17.37.33.57.49l.2.15c.366.29.75.557 1.15.8l.24.14.54.29.22.11c1.036.5 2.137.854 3.27 1.05l.57.08.59.06h69.56l.57-.08.31-.06.29-.06c.267-.06.537-.13.81-.21l.21-.07.61-.2.26-.11.26-.1.22-.1c.28-.12.54-.26.81-.4l.24-.14.48-.29.21-.2c.23-.16.46-.32.68-.49l.2-.16.45-.38.19-.18c.21-.19.42-.4.61-.61a4.64 4.64 0 00.37-.41l.19-.22c.062-.069.119-.142.17-.22l.17-.22.16-.23.15-.2c.14-.22.28-.44.41-.67.13-.23.1-.16.14-.24.04-.08.09-.16.13-.24l.18-.35.12-.25c.09-.2.17-.39.25-.59.031-.065.058-.132.08-.2l.1-.27.09-.27c.407-1.216.619-2.488.63-3.77z"
        ></path>
        <path
          fill="url(#paint26_linear_4045_1012)"
          d="M472.65 108.76v1.16a12.23 12.23 0 00-11-12.15h-69.03a12.221 12.221 0 00-11.64 12.19v-1.16-.36a2.432 2.432 0 010-.27V107.29a1.068 1.068 0 000-.16v-.19-.3c0-.1.07-.35.11-.52.014-.085.034-.168.06-.25.06-.26.13-.51.21-.75 0-.08.05-.16.07-.24.02-.08.07-.19.1-.28l.09-.23c0-.07.05-.13.08-.19l.09-.23c0-.06 0-.12.08-.17l.12-.25c.07-.15.14-.29.22-.43.031-.076.067-.15.11-.22l.15-.25c.335-.579.72-1.128 1.15-1.64l.18-.21.21-.24.37-.38.42-.4.43-.37.22-.18.46-.34.47-.33.48-.29.25-.15.26-.13.25-.13.26-.13.53-.23.26-.1.26-.09.26-.09.3-.09.28-.08.28-.08.29-.07.58-.11.29-.05.64-.07H461.95l.3.05.29.05.29.06.26.06h.05l.25.06.34.1.23.07.5.18.34.13.24.1.27.12.25.13c.614.297 1.199.648 1.75 1.05l.2.14c.25.19.48.37.71.57l.29.27c.392.365.76.756 1.1 1.17l.18.22c.12.16.24.31.35.47l.17.24c.09.14.19.28.27.43l.14.21c.07.14.15.28.23.42l.11.21c.12.23.23.47.34.71.022.068.049.135.08.2.1.24.19.48.28.73l.09.28c.161.542.291 1.093.39 1.65V108.36c0 .19.41.28.41.4z"
        ></path>
        <path
          fill="#3E3E3E"
          d="M471.46 108.1v-.12a5.452 5.452 0 00-.06-.57 1.615 1.615 0 000-.22v-.48a1.423 1.423 0 000-.16c0-.12 0-.24-.08-.36s-.12-.46-.2-.69c-.08-.23-.12-.34-.18-.51a1.447 1.447 0 00-.08-.22l-.21-.49c0-.1-.09-.19-.13-.29-.09-.18-.2-.37-.3-.55l-.05-.09v-.06a.357.357 0 000-.08l-.1-.18-.23-.34a1.302 1.302 0 00-.13-.19c-.05-.07-.1-.15-.16-.22l-.39-.49-.24-.27-.45-.47a2.59 2.59 0 00-.25-.23.463.463 0 00-.07-.07l-.26-.23-.26-.22-.21-.17a3.945 3.945 0 00-.33-.23l-.34-.23-.24-.15h-.07l-.28-.16-.17-.09-.19-.1-.2-.1h-.08l-.47-.21h-.09l-.26-.1H464.47l-.41-.13-.47-.13-.52-.12-.3-.06h-.18a.8.8 0 01-.15 0h-.18l-.75-.06h-69.43c-.35 0-.69.09-1 .15-.18 0-.35.07-.52.12-.17.05-.55.15-.82.24a10.704 10.704 0 00-1.55.66 7.55 7.55 0 00-.73.41l-.46.3-.45.33a4.142 4.142 0 00-.39.31c-.19.16-.38.32-.56.5l-.34.34c-.237.248-.46.509-.67.78-.11.13-.21.27-.31.41-.1.14-.2.28-.29.43l-.23.37a10.836 10.836 0 00-.92 2c-.06.16-.11.33-.16.5-.082.252-.149.51-.2.77-.06.26-.11.52-.15.78-.04.26-.09.367-.15.32v162.4c-.005.07-.005.14 0 .21 0 .2 0 .4.05.6.05.2 0 .26 0 .39v.52a.273.273 0 010 .07.18.18 0 000 .08.085.085 0 000 .05c.019.136.049.269.09.4v.19a.072.072 0 000 .05.417.417 0 000 .05c0 .14.08.27.13.4v.06l.15.42v.06c.12.32.27.63.42.94l.2.36c.158.292.335.572.53.84a.558.558 0 00.09.14l.2.27.07.1c.034.049.07.096.11.14l.12.15.09.1v.11l.09.11a.193.193 0 00.06.07l.13.14.15.15c.2.21.42.41.65.61l.06.06.29.23c.06.058.127.109.2.15a.328.328 0 00.09.08l.11.07.07.05.17.11c.181.126.368.243.56.35l.39.22c.162.09.329.17.5.24l.41.18c.327.131.661.245 1 .34.266.084.537.154.81.21h.11c.284.062.571.109.86.14H461.15c.2 0 .4-.03.6-.09h.19l.43-.1h.09c.079-.011.156-.031.23-.06h.31l.18-.06.24-.08h.09l.38-.15c.13-.048.257-.105.38-.17h.07a.078.078 0 00.06 0h.11l.29-.15.25-.13.14-.08.33-.2.09-.06c.077-.041.151-.088.22-.14.2-.14.4-.28.59-.43l.22-.18.15-.13c.107-.079.207-.166.3-.26l.11-.12c.18-.17.36-.35.52-.53l.39-.45v-.06l.19-.25c.1-.14.2-.27.29-.41l.08-.12c.06-.07.1-.15.15-.22.037-.051.07-.104.1-.16v-.09a.998.998 0 00.1-.17.534.534 0 000-.08l.21-.39v-.05c0-.12.11-.24.16-.35.14-.293.263-.593.37-.9.07-.19.13-.38.19-.58l.12-.44a.752.752 0 010-.15.085.085 0 010-.05v-.05a.817.817 0 000-.07.085.085 0 000-.05.18.18 0 000-.08.273.273 0 010-.07v-.48c.01-.08.01-.16 0-.24.03-.202.05-.406.06-.61V108.76c1.35-.22 1.34-.44 1.33-.66zm-.91 161.94c.002.452-.031.903-.1 1.35 0 0 0 .31-.08.46-.08.15-.05.28-.08.41a2.924 2.924 0 01-.11.4 10.252 10.252 0 01-2.83 4.65 9.997 9.997 0 01-6.11 2.73h-68.86a10.001 10.001 0 01-6-2.66 9.31 9.31 0 01-.54-.55 9.765 9.765 0 01-.77-.94l-.37-.56c-.08-.12-.15-.24-.22-.37a6.102 6.102 0 01-.32-.61c-.09-.18-.17-.35-.24-.53-.08-.183-.15-.37-.21-.56-.08-.23-.15-.45-.21-.68-.06-.23-.11-.47-.16-.71s-.05-.28-.07-.42a6.006 6.006 0 01-.08-.72V108.76v-.42a1.615 1.615 0 010-.22 1.472 1.472 0 010-.21c0-.26 0-.51.09-.77a7.41 7.41 0 01.17-.82c0-.14.07-.28.11-.41a10.484 10.484 0 01.6-1.57c.13-.25.26-.5.41-.74.15-.24.29-.47.45-.69.16-.22.18-.26.28-.38.1-.12.4-.48.61-.71.096-.108.199-.208.31-.3l.12-.12a10 10 0 016.31-2.66H460.91a9.908 9.908 0 017.42 3.89c.105.117.199.245.28.38.188.251.359.515.51.79.088.133.165.274.23.42.004.03.004.06 0 .09.136.249.256.506.36.77a.636.636 0 01.06.18c.03.042.051.09.06.14l.06.17.12.36c.029.082.053.165.07.25 0 .19.1.39.14.58.04.158.07.318.09.48a.072.072 0 010 .05.506.506 0 010 .11v1.5l.24 161.14z"
        ></path>
        <path
          fill="url(#paint27_linear_4045_1012)"
          d="M470.55 108.82v161.22a9.794 9.794 0 01-.43 2.88 10.002 10.002 0 01-.89 2.09l-.24.4c-.13.19-.26.39-.4.57a9.54 9.54 0 01-1.3 1.46 10.421 10.421 0 001.39-5.23v-1.85-161.55-2.16a10.54 10.54 0 00-1.39-5.27 10.115 10.115 0 013.26 7.44z"
        ></path>
        <path
          fill="#000"
          d="M468.38 104.15a9.184 9.184 0 00-7.46-4.56h-37.38v2.45h38.02l.3.05h.06l.24.06.35.11.28.09.3.12c.191.08.378.17.56.27.17.09.34.19.49.29l.11.08.19.13.25.19c.16.129.314.266.46.41l.22.23.21.23c.271.308.509.643.71 1 .107.181.203.368.29.56.08.19.16.38.23.58.07.2.07.2.1.3.069.219.122.443.16.67v.27c.044.332.068.666.07 1v157h2.45v-157a9.105 9.105 0 00-1.21-4.53zm-83.41 144.64h-.93v12h.93v5h1.52v-21.51h-1.52v4.51zm83.41-144.64a9.184 9.184 0 00-7.46-4.56H392.7a9.147 9.147 0 00-7.42 4.56 9.083 9.083 0 00-1.2 4.54v161.29c0 1.578.41 3.128 1.19 4.5a9.186 9.186 0 007.26 4.66h68.65a9.18 9.18 0 007.26-4.67 9.083 9.083 0 001.18-4.47V108.76a9.104 9.104 0 00-1.24-4.61zm-1.2 165.83a6.72 6.72 0 01-1.4 4.09l-.14.18c-.15.17-.31.35-.47.51-.146.144-.3.281-.46.41a6.308 6.308 0 01-1.29.84l-.35.17-.36.14a7.171 7.171 0 01-.76.22c-.33.072-.664.122-1 .15h-68.26a6.765 6.765 0 01-4.402-2.152 6.764 6.764 0 01-1.798-4.558V108.76a6.725 6.725 0 011.817-4.603 6.726 6.726 0 014.473-2.117h68.78l.3.05h.06l.24.06.35.11.28.09.3.12c.191.08.378.17.56.27.17.09.34.19.49.29l.11.08.19.13.25.19c.16.129.314.266.46.41l.22.23.21.23c.271.308.509.643.71 1 .107.181.203.368.29.56.08.19.16.38.23.58.07.2.07.2.1.3.069.219.122.443.16.67v.27c.044.332.068.666.07 1l.04 161.3z"
        ></path>
        <path
          fill="#000"
          d="M404.46 105.13l-.06-.14v-.05c.01.04.03.13.06.19zM449.28 104.98v.05l-.06.14c.01-.1.03-.19.06-.19z"
        ></path>
        <path
          fill="#000"
          d="M450.74 102.03a1.11 1.11 0 00-1.06 1v.11c0 .2-.02.4-.06.6.006.067.006.133 0 .2a2.005 2.005 0 01-.06.24c-.013.074-.03.148-.05.22v.05c0 .05 0 0 0 0v.08a.817.817 0 000 .07 1.443 1.443 0 01-.07.19v.05l-.06.14c-.023.052-.05.102-.08.15a.611.611 0 01-.07.14.41.41 0 010 .07v.27a.41.41 0 000 .07.184.184 0 01-.05.07v.07l-.07.07v.06a.328.328 0 01-.08.09l-.05.06-.06.06-.06.06-.11.11-.09.08-.05.05-.13.11-.13.1-.07.06h-.07l-.09.06-.09.05-.12.08-.16.08h-.06a.311.311 0 01-.11.06h-.11l-.09.05-.2.07-.23.08h-.26l-.48.1h-37.69l-.49-.1h-.26l-.23-.08-.2-.07-.09-.05h-.11a.248.248 0 01-.11-.06h-.06l-.15-.08-.12-.08-.09-.05h-.05l-.09-.06h-.07l-.08-.06-.12-.1-.08-.06v-.05l-.06-.05-.08-.08a1.142 1.142 0 01-.11-.11l-.06-.06-.06-.06-.06-.06-.08-.09a.201.201 0 010-.06l-.06-.07-.05-.07-.05-.07v-.25a.451.451 0 010-.09.165.165 0 010-.07.611.611 0 01-.07-.14 1.08 1.08 0 01-.08-.15c0-.06 0-.12-.08-.19s-.05-.13-.08-.19a.273.273 0 010-.07v-.08-.05c0-.05 0 0 0 0l-.06-.22a1.966 1.966 0 01-.05-.24 1.113 1.113 0 010-.2 4.026 4.026 0 01-.06-.6.752.752 0 010-.15 1.119 1.119 0 00-1.06-1l46.83.04zM404.3 104.75v-.07s-.01.04 0 .07zM404.46 105.13l-.06-.14v-.05c.01.04.03.13.06.19zM405.12 106.21l-.07-.09.07.09zM405.25 106.37l-.05-.06c.013.023.03.043.05.06zM405.43 106.57l-.06-.06.06.06zM406.05 107.14l-.12-.1-.08-.06v-.05l.13.11.07.1zM406.18 107.2l.09.06-.09-.06zM407.51 107.98l-.2-.07.2.07zM407.74 107.98h-.11l-.12-.05.23.05zM408.52 108.2h-.26l-.23-.06.49.06zM445.62 108.1l-.22.06H445.18l.44-.06zM446.18 107.98l-.12.05h-.11l.23-.05zM446.18 107.98l.24-.09-.24.09zM447.86 106.98l-.06.05-.07.06-.13.1.13-.1.13-.11z"
        ></path>
        <path
          fill="#000"
          d="M448.29 106.51l-.06.06.05-.06h.01zM448.45 106.31v.06a.387.387 0 00.08-.1l-.08.04zM448.6 106.12l-.06.09v-.07s.06-.01.06-.02zM449.28 104.98v.05l-.06.14c.01-.1.03-.19.06-.19z"
        ></path>
        <path
          fill="url(#paint28_linear_4045_1012)"
          d="M468.68 270.36v1.85a10.424 10.424 0 01-1.39 5.23 10.063 10.063 0 01-6 2.67h-69.25a9.998 9.998 0 01-5.66-2.63 10.465 10.465 0 01-1.4-5.24v-2.26a8.256 8.256 0 00.761 3.454 8.253 8.253 0 002.139 2.816 8.182 8.182 0 004.69 1.95h68.54a8.259 8.259 0 007.57-7.84z"
        ></path>
        <path
          fill="url(#paint29_linear_4045_1012)"
          d="M470.55 108.82a10.1 10.1 0 00-9.57-10.1h-68.95a10.048 10.048 0 00-5.66 2.61 10.48 10.48 0 00-1.39 5.26v2.18a8.262 8.262 0 012.89-6.28 8.21 8.21 0 014.86-2h68.15a8.24 8.24 0 017.8 7.9v-1.82a10.54 10.54 0 00-1.39-5.27 10.105 10.105 0 013.26 7.52z"
        ></path>
        <path
          fill="url(#paint30_linear_4045_1012)"
          d="M386.38 277.4a10.137 10.137 0 01-3.27-7.43V108.76a10.076 10.076 0 013.26-7.44 10.497 10.497 0 00-1.4 5.26v165.57a10.442 10.442 0 001.41 5.25z"
        ></path>
        <path
          fill="url(#paint31_linear_4045_1012)"
          d="M470.55 108.82v161.22a9.794 9.794 0 01-.43 2.88 10.002 10.002 0 01-.89 2.09l-.24.4c-.13.19-.26.39-.4.57a9.17 9.17 0 01-1.31 1.48 10.421 10.421 0 001.39-5.23V106.65a10.54 10.54 0 00-1.39-5.27 10.107 10.107 0 013.27 7.44z"
        ></path>
        <path
          fill="url(#paint32_linear_4045_1012)"
          d="M431.59 102.75h-10.07a.33.33 0 00-.33.33v.47c0 .182.148.33.33.33h10.07a.33.33 0 00.33-.33v-.47a.33.33 0 00-.33-.33z"
        ></path>
        <path
          fill="url(#paint33_linear_4045_1012)"
          d="M387.18 270.08l-.09-.1c.033.03.063.064.09.1z"
        ></path>
        <path
          fill="url(#paint34_linear_4045_1012)"
          d="M392.85 276.7h-.03l-.02-.01h.02l.03.01z"
        ></path>
        <path
          fill="url(#paint35_linear_4045_1012)"
          d="M405.25 106.37l-.05-.06c.013.023.03.043.05.06z"
        ></path>
        <path
          fill="url(#paint36_linear_4045_1012)"
          d="M448.29 106.51l-.06.06.05-.06h.01z"
        ></path>
        <path
          fill="url(#paint37_linear_4045_1012)"
          d="M460.86 276.69l-.02.01h-.03l.03-.01h.02z"
        ></path>
        <path
          fill="url(#paint38_linear_4045_1012)"
          d="M387.14 269.98l.09.1a.718.718 0 00-.05-.1h-.04zm4.42 3.21h.07-.07z"
        ></path>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4045_1012"
          x1="356.97"
          x2="481.13"
          y1="125.78"
          y2="249.95"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_4045_1012"
          x1="613.75"
          x2="602.72"
          y1="162.58"
          y2="162.58"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0"></stop>
          <stop offset="0.06" stopColor="#DDD"></stop>
          <stop offset="0.14" stopColor="#C7C7C7"></stop>
          <stop offset="0.24" stopColor="#B6B6B6"></stop>
          <stop offset="0.37" stopColor="#AAA"></stop>
          <stop offset="0.54" stopColor="#A3A3A3"></stop>
          <stop offset="1" stopColor="#A1A1A1"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_4045_1012"
          x1="345.68"
          x2="345.91"
          y1="60.22"
          y2="60.22"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A1A1"></stop>
          <stop offset="0.46" stopColor="#A3A3A3"></stop>
          <stop offset="0.63" stopColor="#AAA"></stop>
          <stop offset="0.76" stopColor="#B6B6B6"></stop>
          <stop offset="0.86" stopColor="#C7C7C7"></stop>
          <stop offset="0.94" stopColor="#DDD"></stop>
          <stop offset="1" stopColor="#F0F0F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_4045_1012"
          x1="6271.31"
          x2="6371.74"
          y1="-3614.06"
          y2="-3614.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1A1A1"></stop>
          <stop offset="0.46" stopColor="#A3A3A3"></stop>
          <stop offset="0.63" stopColor="#AAA"></stop>
          <stop offset="0.76" stopColor="#B6B6B6"></stop>
          <stop offset="0.86" stopColor="#C7C7C7"></stop>
          <stop offset="0.94" stopColor="#DDD"></stop>
          <stop offset="1" stopColor="#F0F0F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_4045_1012"
          x1="132703"
          x2="171512"
          y1="-4143.96"
          y2="-4143.96"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9C9C9"></stop>
          <stop offset="0.48" stopColor="#F0F0F0"></stop>
          <stop offset="0.64" stopColor="#EBEBEB"></stop>
          <stop offset="0.82" stopColor="#DDD"></stop>
          <stop offset="1" stopColor="#C9C9C9"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_4045_1012"
          x1="27079.4"
          x2="29085.1"
          y1="-1652.85"
          y2="-1652.85"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C9C9C9"></stop>
          <stop offset="0.48" stopColor="#F0F0F0"></stop>
          <stop offset="0.64" stopColor="#EBEBEB"></stop>
          <stop offset="0.82" stopColor="#DDD"></stop>
          <stop offset="1" stopColor="#C9C9C9"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_4045_1012"
          x1="193.25"
          x2="193.25"
          y1="268.53"
          y2="260.78"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#575453"></stop>
          <stop offset="0.46" stopColor="#575453"></stop>
          <stop offset="1" stopColor="#0B0B0B"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_4045_1012"
          x1="959.029"
          x2="959.029"
          y1="225.924"
          y2="225.879"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#575453"></stop>
          <stop offset="0.46" stopColor="#575453"></stop>
          <stop offset="1" stopColor="#0B0B0B"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_4045_1012"
          x1="194.75"
          x2="-0.01"
          y1="259.81"
          y2="259.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#565656"></stop>
          <stop offset="0.01" stopColor="#464646"></stop>
          <stop offset="0.02" stopColor="#5D5D5D"></stop>
          <stop offset="0.03" stopColor="#7D7D7D"></stop>
          <stop offset="0.4" stopColor="#838383"></stop>
          <stop offset="0.41" stopColor="#838383"></stop>
          <stop offset="0.94" stopColor="#6A6A6A"></stop>
          <stop offset="0.96" stopColor="#454545"></stop>
          <stop offset="0.97" stopColor="#353535"></stop>
          <stop offset="0.98" stopColor="#3A3A3A"></stop>
          <stop offset="0.99" stopColor="#606060"></stop>
          <stop offset="1" stopColor="#7D7D7D"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_4045_1012"
          x1="273.1"
          x2="386.49"
          y1="259.81"
          y2="259.81"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C2C2C"></stop>
          <stop offset="0.01" stopColor="#1C1C1C"></stop>
          <stop offset="0.02" stopColor="#343434"></stop>
          <stop offset="0.03" stopColor="#555"></stop>
          <stop offset="0.4" stopColor="#5E5E5E"></stop>
          <stop offset="0.41" stopColor="#5E5E5E"></stop>
          <stop offset="0.94" stopColor="#424242"></stop>
          <stop offset="0.96" stopColor="#1A1A1A"></stop>
          <stop offset="0.97" stopColor="#0A0A0A"></stop>
          <stop offset="0.98" stopColor="#0F0F0F"></stop>
          <stop offset="0.99" stopColor="#353535"></stop>
          <stop offset="1" stopColor="#555"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_4045_1012"
          x1="784.842"
          x2="785.305"
          y1="979.104"
          y2="979.104"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2C2C2C"></stop>
          <stop offset="0.01" stopColor="#1C1C1C"></stop>
          <stop offset="0.02" stopColor="#343434"></stop>
          <stop offset="0.03" stopColor="#555"></stop>
          <stop offset="0.4" stopColor="#5E5E5E"></stop>
          <stop offset="0.41" stopColor="#5E5E5E"></stop>
          <stop offset="0.94" stopColor="#424242"></stop>
          <stop offset="0.96" stopColor="#1A1A1A"></stop>
          <stop offset="0.97" stopColor="#0A0A0A"></stop>
          <stop offset="0.98" stopColor="#0F0F0F"></stop>
          <stop offset="0.99" stopColor="#353535"></stop>
          <stop offset="1" stopColor="#555"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_4045_1012"
          x1="194.75"
          x2="273.1"
          y1="259.92"
          y2="259.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#555"></stop>
          <stop offset="0.06" stopColor="#424242"></stop>
          <stop offset="0.51" stopColor="#555"></stop>
          <stop offset="0.94" stopColor="#424242"></stop>
          <stop offset="1" stopColor="#555"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_4045_1012"
          x1="194.75"
          x2="-0.01"
          y1="259.41"
          y2="259.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6D6D6D"></stop>
          <stop offset="0.01" stopColor="#505050"></stop>
          <stop offset="0.02" stopColor="#767676"></stop>
          <stop offset="0.03" stopColor="#6C6968"></stop>
          <stop offset="0.4" stopColor="#6C6968"></stop>
          <stop offset="0.41" stopColor="#6C6968"></stop>
          <stop offset="0.94" stopColor="#8D8D8D"></stop>
          <stop offset="0.95" stopColor="#5F5F5F"></stop>
          <stop offset="0.97" stopColor="#272727"></stop>
          <stop offset="0.98" stopColor="#2C2C2C"></stop>
          <stop offset="0.99" stopColor="#525050"></stop>
          <stop offset="1" stopColor="#6C6968"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_4045_1012"
          x1="233.94"
          x2="233.94"
          y1="256.98"
          y2="1.67"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#504D4D"></stop>
          <stop offset="0.09" stopColor="#585555"></stop>
          <stop offset="0.24" stopColor="#6E6A6A"></stop>
          <stop offset="0.41" stopColor="#918C8C"></stop>
          <stop offset="0.45" stopColor="#999494"></stop>
          <stop offset="1" stopColor="#7D7979"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_4045_1012"
          x1="233.93"
          x2="233.93"
          y1="13.33"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#131313"></stop>
          <stop offset="0.28" stopColor="#161616"></stop>
          <stop offset="0.44" stopColor="#1E1E1E"></stop>
          <stop offset="0.58" stopColor="#2C2C2C"></stop>
          <stop offset="0.7" stopColor="#404040"></stop>
          <stop offset="0.81" stopColor="#5B5B5B"></stop>
          <stop offset="0.91" stopColor="#7A7A7A"></stop>
          <stop offset="1" stopColor="#9F9F9F"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_4045_1012"
          x1="273.1"
          x2="386.49"
          y1="259.4"
          y2="259.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444"></stop>
          <stop offset="0.01" stopColor="#272727"></stop>
          <stop offset="0.02" stopColor="#4E4E4E"></stop>
          <stop offset="0.03" stopColor="#6C6968"></stop>
          <stop offset="0.4" stopColor="#6C6968"></stop>
          <stop offset="0.41" stopColor="#6C6968"></stop>
          <stop offset="0.94" stopColor="#686868"></stop>
          <stop offset="0.95" stopColor="#434343"></stop>
          <stop offset="0.96" stopColor="#1B1B1B"></stop>
          <stop offset="0.97" stopColor="#0B0B0B"></stop>
          <stop offset="0.98" stopColor="#1E1E1E"></stop>
          <stop offset="0.99" stopColor="#363535"></stop>
          <stop offset="1" stopColor="#6C6968"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_4045_1012"
          x1="784.842"
          x2="785.305"
          y1="977.592"
          y2="977.592"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#444"></stop>
          <stop offset="0.01" stopColor="#272727"></stop>
          <stop offset="0.02" stopColor="#4E4E4E"></stop>
          <stop offset="0.03" stopColor="#6C6968"></stop>
          <stop offset="0.4" stopColor="#6C6968"></stop>
          <stop offset="0.41" stopColor="#6C6968"></stop>
          <stop offset="0.94" stopColor="#686868"></stop>
          <stop offset="0.95" stopColor="#434343"></stop>
          <stop offset="0.96" stopColor="#1B1B1B"></stop>
          <stop offset="0.97" stopColor="#0B0B0B"></stop>
          <stop offset="0.98" stopColor="#1E1E1E"></stop>
          <stop offset="0.99" stopColor="#363535"></stop>
          <stop offset="1" stopColor="#6C6968"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_4045_1012"
          x1="194.75"
          x2="273.1"
          y1="259.52"
          y2="259.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#848180"></stop>
          <stop offset="0.06" stopColor="#6C6968"></stop>
          <stop offset="0.51" stopColor="#848180"></stop>
          <stop offset="0.94" stopColor="#6C6968"></stop>
          <stop offset="1" stopColor="#848180"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_4045_1012"
          x1="429.666"
          x2="429.67"
          y1="23.678"
          y2="23.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_4045_1012"
          x1="472.012"
          x2="472.016"
          y1="5.115"
          y2="5.123"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_4045_1012"
          x1="629.538"
          x2="629.562"
          y1="-39.59"
          y2="-39.543"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_4045_1012"
          x1="21836.1"
          x2="26704.7"
          y1="-44426.5"
          y2="-43280.6"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_4045_1012"
          x1="269.98"
          x2="269.98"
          y1="257.6"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.2" stopColor="#fff"></stop>
          <stop offset="0.89" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_4045_1012"
          x1="381.01"
          x2="382.36"
          y1="189.34"
          y2="189.34"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#666"></stop>
          <stop offset="0.05" stopColor="#717171"></stop>
          <stop offset="0.33" stopColor="#A8A8A8"></stop>
          <stop offset="0.57" stopColor="#CFCFCF"></stop>
          <stop offset="0.75" stopColor="#E7E7E7"></stop>
          <stop offset="0.87" stopColor="#F0F0F0"></stop>
          <stop offset="0.94" stopColor="#F6F6F6"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_4045_1012"
          x1="471.51"
          x2="472.85"
          y1="189.35"
          y2="189.35"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.06" stopColor="#F6F6F6"></stop>
          <stop offset="0.13" stopColor="#F0F0F0"></stop>
          <stop offset="0.25" stopColor="#E7E7E7"></stop>
          <stop offset="0.43" stopColor="#CFCFCF"></stop>
          <stop offset="0.67" stopColor="#A8A8A8"></stop>
          <stop offset="0.95" stopColor="#717171"></stop>
          <stop offset="1" stopColor="#666"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_4045_1012"
          x1="426.83"
          x2="426.83"
          y1="282.19"
          y2="271.47"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0"></stop>
          <stop offset="0.12" stopColor="#E2E2E2"></stop>
          <stop offset="0.33" stopColor="#BEBEBE"></stop>
          <stop offset="0.63" stopColor="#838383"></stop>
          <stop offset="0.99" stopColor="#323232"></stop>
          <stop offset="1" stopColor="#303030"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_4045_1012"
          x1="426.83"
          x2="426.83"
          y1="106.77"
          y2="93.4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#303030"></stop>
          <stop offset="0.08" stopColor="#4C4C4C"></stop>
          <stop offset="0.26" stopColor="#828282"></stop>
          <stop offset="0.43" stopColor="#AFAFAF"></stop>
          <stop offset="0.59" stopColor="#D2D2D2"></stop>
          <stop offset="0.75" stopColor="#EBEBEB"></stop>
          <stop offset="0.89" stopColor="#FAFAFA"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_4045_1012"
          x1="467.29"
          x2="470.55"
          y1="189.41"
          y2="189.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0F0F0"></stop>
          <stop offset="0.01" stopColor="#EDEDED"></stop>
          <stop offset="0.14" stopColor="#B4B4B4"></stop>
          <stop offset="0.27" stopColor="#858585"></stop>
          <stop offset="0.4" stopColor="#606060"></stop>
          <stop offset="0.51" stopColor="#464646"></stop>
          <stop offset="0.62" stopColor="#363636"></stop>
          <stop offset="0.7" stopColor="#303030"></stop>
        </linearGradient>
        <linearGradient
          id="paint28_linear_4045_1012"
          x1="384.98"
          x2="468.68"
          y1="275.08"
          y2="275.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="0.1" stopColor="#121212"></stop>
          <stop offset="0.25" stopColor="#2A2A2A"></stop>
          <stop offset="0.4" stopColor="#393939"></stop>
          <stop offset="0.52" stopColor="#3E3E3E"></stop>
          <stop offset="0.63" stopColor="#373737"></stop>
          <stop offset="0.8" stopColor="#222"></stop>
          <stop offset="1"></stop>
        </linearGradient>
        <linearGradient
          id="paint29_linear_4045_1012"
          x1="55218.5"
          x2="62540.8"
          y1="-3165.8"
          y2="-3165.8"
          gradientUnits="userSpaceOnUse"
        >
          <stop></stop>
          <stop offset="0.1" stopColor="#121212"></stop>
          <stop offset="0.25" stopColor="#2A2A2A"></stop>
          <stop offset="0.4" stopColor="#393939"></stop>
          <stop offset="0.52" stopColor="#3E3E3E"></stop>
          <stop offset="0.63" stopColor="#373737"></stop>
          <stop offset="0.8" stopColor="#222"></stop>
          <stop offset="1"></stop>
        </linearGradient>
        <linearGradient
          id="paint30_linear_4045_1012"
          x1="383.11"
          x2="385.04"
          y1="189.36"
          y2="189.36"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E3E3E"></stop>
          <stop offset="0.03" stopColor="#3C3C3C"></stop>
          <stop offset="0.67" stopColor="#131313"></stop>
          <stop offset="1" stopColor="#030303"></stop>
        </linearGradient>
        <linearGradient
          id="paint31_linear_4045_1012"
          x1="467.28"
          x2="470.55"
          y1="189.42"
          y2="189.42"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#030303"></stop>
          <stop offset="0.33" stopColor="#131313"></stop>
          <stop offset="0.97" stopColor="#3C3C3C"></stop>
          <stop offset="1" stopColor="#3E3E3E"></stop>
        </linearGradient>
        <linearGradient
          id="paint32_linear_4045_1012"
          x1="421.19"
          x2="431.91"
          y1="103.31"
          y2="103.31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#303030"></stop>
          <stop offset="0.12" stopColor="#242424"></stop>
          <stop offset="0.3" stopColor="#171717"></stop>
          <stop offset="0.48" stopColor="#131313"></stop>
          <stop offset="0.78" stopColor="#151515"></stop>
          <stop offset="0.89" stopColor="#1C1C1C"></stop>
          <stop offset="0.96" stopColor="#272727"></stop>
          <stop offset="1" stopColor="#303030"></stop>
        </linearGradient>
        <linearGradient
          id="paint33_linear_4045_1012"
          x1="444.972"
          x2="444.982"
          y1="254.279"
          y2="254.287"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint34_linear_4045_1012"
          x1="412.448"
          x2="412.448"
          y1="279.46"
          y2="279.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint35_linear_4045_1012"
          x1="438.243"
          x2="438.246"
          y1="87.061"
          y2="87.064"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint36_linear_4045_1012"
          x1="490.472"
          x2="490.473"
          y1="87.284"
          y2="87.284"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint37_linear_4045_1012"
          x1="483.846"
          x2="483.846"
          y1="279.46"
          y2="279.46"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2F3"></stop>
          <stop offset="0.36" stopColor="#ECEDEE"></stop>
          <stop offset="0.8" stopColor="#DEDFDF"></stop>
          <stop offset="1" stopColor="#D5D6D6"></stop>
        </linearGradient>
        <linearGradient
          id="paint38_linear_4045_1012"
          x1="427.89"
          x2="427.89"
          y1="273.91"
          y2="266.97"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.85" stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff"></stop>
        </linearGradient>
        <clipPath id="clip0_4045_1012">
          <path fill="#fff" d="M0 0H613.87V282.53H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default Devices;
